const CALL_ROLE_BY_PROGRAM_PREFIX: [string, string][] = [
  ['psychiatrist_intake', 'psychiatrist'],
  ['master_v5', 'therapist'],
  ['coaching', 'coach'],
]

export const callRoleForProgram = (programID: string | undefined): string | undefined =>
  CALL_ROLE_BY_PROGRAM_PREFIX.find(([prefix]) => programID?.startsWith(prefix))?.[1]

export const canProvideCall = (roles: string[] | undefined, programID: string | undefined): boolean => {
  const callRole = callRoleForProgram(programID)

  return callRole !== undefined && !!roles?.includes(callRole)
}
